import { render, staticRenderFns } from "./Jingsu.vue?vue&type=template&id=cf65f312&scoped=true"
import script from "./Jingsu.vue?vue&type=script&lang=js"
export * from "./Jingsu.vue?vue&type=script&lang=js"
import style0 from "./Jingsu.vue?vue&type=style&index=0&id=cf65f312&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf65f312",
  null
  
)

export default component.exports